import {
    getConfigGatewayUrl, transformAppInit
} from '../app';
import { createFetchAction } from '../middleware';
import {
    USER_PROFILES_STATE_NAME, EMAIL_STATUS_NAME
} from './user-profiles.reducer';

export const fetchGetUserProfilesRequest = () => {
    return createFetchAction({
        name: USER_PROFILES_STATE_NAME,
        body: null,
        method: 'GET',
        resolveUrl: getConfigGatewayUrl({
            key: 'UserPortalGateway',
            basePath: '/api/v1/UserProfiles'
        }),
        transformInit: transformAppInit
    });
};

export const fetchGetEmailStatusRequest = () => {
    return createFetchAction({
        name: EMAIL_STATUS_NAME,
        body: null,
        method: 'GET',
        resolveUrl: getConfigGatewayUrl({
            key: 'UserPortalGateway',
            basePath: '/api/v1/getEmailStatus'
        }),
        transformInit: transformAppInit
    });
};

